import {useCallback, useState} from 'react'
import type {UpdateUserSettingsRequest} from '@app/api-resolver/router'
import {FormFields} from './FormFields.tsx'
import {FormValues} from './FormValues.ts'
import {useUserSettings} from '../../../providers/userSettings/useUserSettings.ts'
import {EditModeButtons} from '../../calendar/components/EditModeButtons.tsx'
import type {UserSettings} from '@package/shared'
import {useForm} from '@mantine/form'
import {zod4Resolver} from 'mantine-form-zod-resolver'

type Props = {
  userSettings: UserSettings
  disabled: boolean
}

export const UpdateForm = ({userSettings, disabled: containerDisabled}: Props) => {
  const {updateUserSettings} = useUserSettings()
  const [updating, setUpdating] = useState<boolean>(false)

  const form = useForm<FormValues>({
    initialValues: userSettings satisfies FormValues,
    validate: zod4Resolver(FormValues),
  })

  // update
  const handleSubmit = useCallback(
    async (formValues: FormValues) => {
      setUpdating(true)
      await updateUserSettings({
        ...userSettings,
        ...formValues,
      } satisfies UpdateUserSettingsRequest).finally(() => setUpdating(false))
    },
    [userSettings, updateUserSettings],
  )

  const disabled = containerDisabled || updating

  return (
    <form onSubmit={form.onSubmit(handleSubmit)} style={{display: 'flex', flexDirection: 'column', gap: 10}}>
      <FormFields form={form} disabled={disabled} />
      <EditModeButtons submitVariant={'update'} submitting={updating} disabled={disabled} />
    </form>
  )
}
